var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-events-header"},[_c('FlagAnimation'),_c('div',{staticClass:"content-header",style:(_vm.headerStyle)},[_vm._v(" "+_vm._s(_vm.header)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }